var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestiicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.751099,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0675F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 42.0844C34.6666 39.9627 33.8238 37.9278 32.3235 36.4276C30.8232 34.9273 28.7884 34.0844 26.6666 34.0844C24.5449 34.0844 22.5101 34.9273 21.0098 36.4276C19.5095 37.9278 18.6666 39.9627 18.6666 42.0844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 34.0845C29.6122 34.0845 32 31.6966 32 28.7511C32 25.8056 29.6122 23.4178 26.6667 23.4178C23.7212 23.4178 21.3334 25.8056 21.3334 28.7511C21.3334 31.6966 23.7212 34.0845 26.6667 34.0845Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 42.0845C45.3334 39.9627 44.4905 37.9279 42.9902 36.4276C41.4899 34.9273 39.4551 34.0845 37.3334 34.0845C38.7479 34.0845 40.1044 33.5225 41.1046 32.5224C42.1048 31.5222 42.6667 30.1656 42.6667 28.7511C42.6667 27.3366 42.1048 25.9801 41.1046 24.9799C40.1044 23.9797 38.7479 23.4178 37.3334 23.4178",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestiicon1);
export default __webpack_public_path__ + "static/media/destiicon1.a4541ae122628e6d9d86e1443b50d529.svg";
export { ForwardRef as ReactComponent };